export default {
  black: '#2A363B',
  darkGrey: '#545E62',
  lightGrey: '#d3d3d3',
  green: '#99B898',
  yellow: '#FECEAB',
  orange: '#FF847C',
  red: '#E84A5F',
  white: 'white',
  opaqueWhite: 'rgba(255, 255, 255, 0.35)',
  opaqueBlack: 'rgba(0, 0, 0, 0.5)'
}



// WEBPACK FOOTER //
// ./src/styles/colors.js